module.exports = __webpack_public_path__ + "static/media/shape_2.3edca152.png";